// extracted by mini-css-extract-plugin
export default {"selected":"BlockSelection_selected__gQg3e","unselected":"BlockSelection_unselected__spjxv"};